import { FormDataModel } from '@/model/FormModel'
import { corporateList, payTypeList } from '@/utils/index'

export const FromFieldData: FormDataModel[] = [
  {
    title: '基本信息',
    type: 1, // 常规表单
    labelClass: 'blue',
    labelName: '基',
    formList: [
      {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'name',
        fieldName: '供应商',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'mainBusiness',
        fieldName: '主营业务',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'website',
        fieldName: '企业网站',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'contactNumber',
        fieldName: '企业联系',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'email',
        fieldName: '企业邮箱',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true
        }
      }, {
        componentType: 'el-cascader-provinces',
        componentName: '省市区级联',
        fieldKey: 'address',
        fieldName: '省市县',
        placeholder: '',
        value: [],
        rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        option: [],
        config: {
          isDisabled: false,
          multiple: true,
          clearable: true,
          filterable: true
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'addressDetail',
        fieldName: '详细地址',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false
        }
      }, {
        componentType: 'el-textarea',
        componentName: '输入框',
        fieldKey: 'mark',
        fieldName: '备注信息',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false,
          width: '100%'
        }
      }
    ]
  }, {
    title: '开票信息',
    type: 1,
    labelClass: 'green',
    labelName: '开',
    formList: [
      {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'titleName',
        fieldName: '发票抬头',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'taxId',
        fieldName: '税号',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'registeredAddress',
        fieldName: '注册地址',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'bank',
        fieldName: '开户银行',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'account',
        fieldName: '银行账号',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'phone',
        fieldName: '电话号码',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false
        }
      }
    ]
  }, {
    title: '账户信息',
    type: 2,
    labelClass: 'blue',
    labelName: '账',
    formList: [
      {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'accounts',
        fieldName: '渲染列表',
        config: {},
        id: 0,
        list: [
          {
            componentType: 'el-select',
            componentName: '下拉选择',
            fieldKey: 'corporate',
            fieldName: '类型',
            placeholder: '',
            value: '',
            rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
            option: corporateList,
            config: {
              isDisabled: false,
              multiple: false,
              pickerType: '',
              uniqueFieldKey: 'outsourceCorporate',
              isHide: false,
              selectType: 3// 1本地2远程
            }
          },
          {
            componentType: 'el-select',
            componentName: '下拉选择',
            fieldKey: 'type',
            fieldName: '支付类型',
            placeholder: '',
            value: '',
            rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
            option: payTypeList,
            config: {
              isDisabled: false,
              multiple: false,
              clearable: true,
              uniqueFieldKey: 'outsourcePayType',
              isHide: true,
              selectType: 3// 1本地2远程
            }
          },
          {
            componentType: 'el-input',
            componentName: '输入框',
            fieldKey: 'name',
            fieldName: '公司全称',
            placeholder: '',
            value: '',
            rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
            config: {
              isDisabled: false,
              clearable: true,
              url: '',
              filterable: false,
              isHide: false
            }
          },
          {
            componentType: 'el-input',
            componentName: '输入框',
            fieldKey: 'no',
            fieldName: '银行账号',
            placeholder: '',
            value: '',
            rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
            config: {
              isDisabled: false,
              clearable: true,
              url: '',
              filterable: false,
              isHide: false
            }
          }, {
            componentType: 'el-input',
            componentName: '输入框',
            fieldKey: 'bank',
            fieldName: '开户行',
            placeholder: '',
            value: '',
            rules: [{ required: true, message: '', trigger: 'change' }],
            config: {
              isDisabled: false,
              clearable: true,
              url: '',
              filterable: false,
              isHide: false
            }
          },
          {
            componentType: 'el-input',
            componentName: '输入框',
            fieldKey: 'bankNo',
            fieldName: '行号',
            placeholder: '',
            value: '',
            rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
            config: {
              isDisabled: false,
              clearable: true,
              url: '',
              isHide: false,
              filterable: false
            }
          }
        ]
      }
    ]
  }
]
